import { connect } from 'react-redux';
import { useConfig } from 'shared/config/ConfigContext';

import { debounce } from 'shared/util/debounce';
import { ApiActionStatus, type ApiQueryParams, type HotelResults, type PaleState } from '@/interfaces';
import { fetchHotelResultsToAppend } from '@/state/hotelResultActions';

interface HotelPaginationProps {
    hotelResults: HotelResults;
    triggerFetch: (apiUrl: string, queryParam?: ApiQueryParams) => void;
}

export const HotelPagination = ({ triggerFetch, hotelResults }: HotelPaginationProps) => {
    const { apiUrl } = useConfig();
    const offersLeft = hotelResults.numberOfOffers - hotelResults.offers.length;
    const fetchMoreOffers = debounce((): void => {
        const nextPage: string = (hotelResults.currentPage + 1).toString();
        if (hotelResults.currentPage + 1 <= hotelResults.totalPages) {
            triggerFetch(apiUrl, { page: nextPage });
        }
    }, 200);

    return (
        <div className="u-text-center u-mb64">
            {offersLeft > 0 ? (
                <button
                    type="button"
                    data-testid="hotel-pagination-button"
                    className="button button--flat"
                    onClick={(): void => fetchMoreOffers()}
                    disabled={hotelResults.status === ApiActionStatus.PENDING}>
                    Last inn {Math.min(12, offersLeft)} av {offersLeft} flere tilbud
                </button>
            ) : null}
        </div>
    );
};

const mapStateToProps = ({ hotelResults }: PaleState): Pick<HotelPaginationProps, 'hotelResults'> => ({ hotelResults });

const mapDispatchToProps = { triggerFetch: fetchHotelResultsToAppend };

export default connect(mapStateToProps, mapDispatchToProps)(HotelPagination);
